export default "__VITE_ASSET__3Wug7sSt__"